@if (isLoadRecords) {
  <div class="loader-container text-danger loader">
    <app-common-icon [loadingIcon]="isLoadRecords"></app-common-icon>
  </div>
}
